import { ILeanProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { IBadgeList } from "@faire/web-api--source/indigofair/badges/IBadgeList";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";

export interface ProductTileTrackingWrapperProps {
  productToken?: string;
  isPromoted?: boolean;
  impressionId?: string;
  promotedBy?: Array<keyof typeof IProduct.PromotedType>;
  badgeList?: IBadgeList;
  bestImage?: IImage;
  images?: Array<IImage>;
  settingsToAssignOnView?: Array<string>;
  recordProductTileImpressionForAds?: boolean;
  selectedProductOptionToken?: string;
}

export const productTileTrackingWrapperPropsILeanProductTileAdapter = (
  productTile: ILeanProductTile
): ProductTileTrackingWrapperProps => {
  return {
    productToken: productTile?.product?.token,
    isPromoted: productTile?.product?.is_promoted,
    impressionId: productTile?.product?.impression_id,
    promotedBy: productTile?.product?.promoted_by,
    badgeList: productTile?.badge_list,
    bestImage: productTile?.best_image,
    images: productTile?.images,
    settingsToAssignOnView: productTile?.settings_to_assign_on_view,
    recordProductTileImpressionForAds: true,
    selectedProductOptionToken: productTile?.selected_product_option_token,
  };
};
